// Remove inline style
// $(document).ready(function (){
//   jQuery("#abz_coll_style").removeInlineCss("color font-size font-weight ");
// });
document.addEventListener("product:variant-change", function (evt) {
  const mpnElements = document.querySelectorAll('.abz-mpn, .abz-upc');
  // const defaultMpn = document.querySelector('.default-mpn');
  // let hasMatch = false;

  mpnElements.forEach(function (element) {
    if (element.dataset.abzVariant == evt.detail.variant.id) { 
      element.classList.add('active');
      // hasMatch = true;
    } else {
      element.classList.remove('active');
    }
  });

  // Handle default MPN visibility
  // if (defaultMpn) {
  //   if (!hasMatch) {
  //     defaultMpn.classList.add('active');
  //   } else {
  //     defaultMpn.classList.remove('active');
  //   }
  // }
});

//On Variant Change, Variant Description Switcher
document.addEventListener("product:variant-change", function (evt) {
  const variant = evt.detail.variant;
  
  // Update Variant Description (existing logic)
  const descriptionElement = document.querySelector('.variant-description');
  const variantMetaFieldElement = document.querySelector(`.variant-description-data[data-variant-id="${variant.id}"]`);
  const variantDescription = variantMetaFieldElement 
    ? variantMetaFieldElement.dataset.variantDescription
    : "No description available for this variant.";
  descriptionElement.innerHTML = variantDescription;

  //console.log("Selected Variant ID:", variant.id);
  //console.log("Variant Color:", variant.option1);
}); 

$(document).ready(function () {
  $("#abz_coll_style").removeAttr("style");
});

// Add to cart short popup
function addedToCartToast() {
  if (!window.addedProduct) return document.getElementById('site-cart-sidebar').show();
  let cartTotal = document.querySelector('#AjaxCartForm [data-cart-total]').textContent;

  iziToast.success({
    animateInside: false,
    backgroundColor: 'var(--color-background-main)',
    close: false,
    displayMode: 2,
    id: null,
    message: 'تمت إضافته إلى عربة التسوق',
    position: 'topRight',
    progressBarColor: 'var(--color-accent-main)',
    theme: 'addedToCartToast',
    timeout: 5000,
    title: window.addedProduct,
    transitionIn: 'fadeInLeft',
    buttons: [
      [
        `<button class="button toast-cart">My&nbsp;cart -&nbsp;<span>${cartTotal}</span></button>`,
        function (instance, toast) {
          document.getElementById('site-cart-sidebar').show();
          instance.hide({ transitionOut: 'fadeOutUp' }, toast)
        },
        false
      ]
    ]
  });
}
var buttonSelector = 'body.template-product span.button__text';
if (Shopify.locale === 'ar') {
  var buttons = document.querySelectorAll(buttonSelector);
  buttons.forEach(function (button) {
    button.textContent = 'أضف إلى السلة';
  });
}
var buttonSelectorSoldOut = 'button.button.button--outline.button--regular.button--fullwidth.button--loader.soldout span.button__text,body.template-product.template-product button.button.button--outline.button--loader.soldout';

if (Shopify.locale === 'ar') {
  var buttons = document.querySelectorAll(buttonSelectorSoldOut);
  buttons.forEach(function (button) {
    button.textContent = 'نفذ';
  });
}

//link open in new tab
var links = document.links;
for (let i = 0, linksLength = links.length; i < linksLength; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}

//readmore-less
$('.moreless').click(function () {
  $('.moretext').slideToggle();
  if ($('.moreless').text() == "Read less") {
    $(this).text("Read more")
  } else {
    $(this).text("Read less")
  }
});

// testi slider
$('#abz-testi-slider').owlCarousel({
  loop: true,
  margin: 10,
  nav: false,
  dots: false,
  autoplay: true,
  autoplayTimeout: 3000,
  autoplayHoverPause: true,
  responsiveClass: true,
  responsive: {
    0: {
      items: 1
    },
    600: {
      items: 1
    },
    1000: {
      items: 1
    }
  }
});

// logo slider
$('#abz-logo-slider').owlCarousel({
  loop: true,
  margin: 10,
  nav: false,
  dots: false,
  autoplay: true,
  autoplayTimeout: 3000,
  autoplayHoverPause: true,
  responsiveClass: true,
  responsive: {
    0: {
      items: 2
    },
    640: {
      items: 3
    },
    1000: {
      items: 6
    }
  }
});

// grid slider
$('.abz-coll-grid-slider').owlCarousel({
  loop: false,
  margin: 20,
  nav: true,
  dots: false,
  autoplay: true,
  autoplayTimeout: 3000,
  autoplayHoverPause: true,
  responsiveClass: true,
  responsive: {
    0: {
      items: 2
    },
    640: {
      items: 3
    },
    1000: {
      items: 4
    }
  }
});


// abz_popuptext (product Page)
  $(".open").click(function () {
    $(".pop-outer").fadeIn("slow");
    $("body").addClass("ab-open-popups");
  });
  $(".close").click(function () {
    $(".pop-outer").fadeOut("slow");
    $("body").removeClass("ab-open-popups");
  });

// abz_map_popup (product Page)
$(document).ready(function () {
  $(".abz_map_open").click(function () {
    $(".abz_pop-outer").fadeIn("slow");
    $("body").addClass("ab-open-popups");
  });
  $(".close").click(function () {
    $(".abz_pop-outer").fadeOut("slow");
    $("body").removeClass("ab-open-popups");
  });
});

// Show the first tab and hide the rest
$('#tabs-nav li:first-child').addClass('active');
$('.tab-content').hide();
$('.tab-content:first-child').show();

// Click function
$('#tabs-nav li').click(function () {
  let temp = $(this);
  let wrapper = temp.closest('.shopify-section');
  let wid = $(wrapper).attr('id');
  let ts = null;
  ts = `#${wid} #tabs-nav li`;

  $(ts).removeClass('active');
  $(this).addClass('active');

  ts = `#${wid} .tab-content`;
  $(ts).hide();

  var activeTab = $(this).find('a').attr('href');
  $(activeTab).fadeIn();
  return false;
  ``
});


// Yotpo review scroll handling
document.addEventListener('click', function(e) {
  let mainElement = document.querySelector('.yotpo.yotpo-main-widget');
  if(mainElement) {
    mainElement = mainElement.closest('.shopify-section');

    if ($(mainElement.previousElementSibling).is('.shopify-section:has([data-section-type="apps"]):has(.section-introduction)')) {
      mainElement = mainElement.previousElementSibling;
    }
  }


  if (e.target.closest('.yotpo-reviews-star-ratings-widget') && mainElement) {
    const headerOffset = 150;
    const elementPosition = mainElement.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
  }
}); 
